<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2021-05-24 09:33:26
    Description : 48资源下载
  -->
  <div class="main">
    <div class="page">
      <div class="h1">资源下载</div>
      <div class="title">文档&表格下载</div>
      <div>
        <img
          class="img"
          src="https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/153449259190016e7.jpg"
        />
        <div class="item">
          <div class="name">标题：2023创作信息表</div>
          <div class="info">描述：docx | 43.3 KB</div>
          <el-button
            type="warning"
            @click="
              open(
                'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/info.docx'
              )
            "
            >下载到本地</el-button
          >
        </div>
        <!--
        <div style="display: inline-block; width: 270px"></div>
        <img
          class="img"
          src="https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/153449259190016e7.jpg"
        />
        <div class="item">
          <div class="name">标题：《工业技术奖申请表》</div>
          <div class="info">描述：docx | 26.8K</div>
          <el-button
            type="warning"
            @click="
              open(
                'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/image/cover/u479785/20191012-171135.docx'
              )
            "
            >下载到本地</el-button
          >
        </div>
        -->
      </div>
      <div class="title">电影海报模板下载</div>
      <div>
        <img
          class="img"
          src="https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/1534492810325c022.jpg"
        />
        <div class="item">
          <div class="name">标题：2023参赛海报模板</div>
          <div class="info">描述：psd | 5.5 MB</div>
          <el-button
            type="warning"
            @click="
              open(
                'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/template.psd'
              )
            "
            >下载到本地</el-button
          >
        </div>
      </div>
      <div class="title">电影节片头下载</div>
      <div>
        <img
          class="img"
          src="https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/1515568758388433d.jpg"
        />
        <div class="item">
          <div class="name">标题：Gaia48_4K_2160p</div>
          <div class="info">描述：mp4 | 4096 x 2160 | 37.9 MB</div>
          <el-button
            type="warning"
            @click="
              open(
                'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/15155688521906502.mp4'
              )
            "
            >下载到本地</el-button
          >
        </div>
      </div>

      <div class="title">虚拟场景下载</div>
      <div>
        <img
          class="img"
          src="https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/Cliff.png"
        />
        <div class="item">
          <div class="name">标题：Cliff</div>
          <div class="info">描述：zip | 7.09 GB</div>
          <el-button
            type="warning"
            @click="
              open(
                'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/Cliff.zip'
              )
            "
          >下载到本地</el-button
          >
        </div>
        <div style="display: inline-block; width: 270px"></div>
        <img
          class="img"
          src="https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/CyberpunkGigapack.png"
        />
        <div class="item">
          <div class="name">标题：CyberpunkGigapack</div>
          <div class="info">描述：zip | 4.87 GB</div>
          <el-button
            type="warning"
            @click="
              open(
                'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/CyberpunkGigapack.zip'
              )
            "
            >下载到本地</el-button
          >
        </div>
      </div>
      <div style="height: 30px"></div>
      <div>
        <img
          class="img"
          src="https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/Hospital.png"
        />
        <div class="item">
          <div class="name">标题：Hospital</div>
          <div class="info">描述：zip | 1.32 GB</div>
          <el-button
            type="warning"
            @click="
              open(
                'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/Hospital.zip'
              )
            "
          >下载到本地</el-button
          >
        </div>
        <div style="display: inline-block; width: 270px"></div>
        <img
          class="img"
          src="https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/ISS_Columbus.png"
        />
        <div class="item">
          <div class="name">标题：ISS_Columbus</div>
          <div class="info">描述：zip | 1.09 GB</div>
          <el-button
            type="warning"
            @click="
              open(
                'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/ISS_Columbus.zip'
              )
            "
          >下载到本地</el-button
          >
        </div>
      </div>
      <div class="title">场景说明</div>
      <div>
        <img
          class="img"
          src="https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/153449259190016e7.jpg"
        />
        <div class="item">
          <div class="name">标题：UE工程注意事项</div>
          <div class="info">描述：docx | 12.5 KB</div>
          <el-button
            type="warning"
            @click="
              open(
                'https://pub-glb.cn-e1.acs-cdn.gaiamount.com/static/gaia48/2312/notice.docx'
              )
            "
          >下载到本地</el-button
          >
        </div>
      </div>

    </div>
    <div style="height: 60px"></div>
  </div>
</template>

<script>
export default {
  methods: {
    open(url) {
      open(url);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  background: #f5f5f5;
  padding-top: 140px;
}
.page {
  padding: 40px 140px;
  background: #ffffff;
}
.h1 {
  width: 100%;
  height: 80px;
  background: #f5f5f5;
  text-align: center;
  line-height: 80px;
  font-size: 28px;
  font-family: Adobe Heiti Std;
}
.title {
  display: inline-block;
  margin: 60px 0 20px 0;
  font-size: 20px;
  line-height: 34px;
  text-align: left;
}
.title::before {
  content: "";
  display: inline-block;
  width: 10px;
  height: 34px;
  margin-right: 10px;
  background: #ffa200;
  vertical-align: bottom;
}
.img {
  width: 170px;
  height: 100px;
}
.name {
  height: 30px;
  font-size: 16px;
  color: #555555;
}
.info {
  height: 36px;
  font-size: 12px;
  color: #a0a0a0;
}
.item {
  display: inline-block;
  padding-left: 20px;
  vertical-align: bottom;
}
</style>
